import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import api from 'services/api';
import { Button } from 'shared/components/atoms/Button/Button';
import {
  Container,
  LeftBottom,
  LeftCenter,
  LeftTop,
  RegisterWrapper,
  RepfyLogo,
  ResetPasswordForm,
  RightBottom,
  RightTop,
} from './_resetPassword';

export const ResetPassword = () => {
  const { search } = useLocation();
  const [resetPasswordFormData, setResetPasswordFormData] = useState({
    password: '',
    passwordConfirmation: '',
  });
  const [wasSent, setWasSent] = useState(false);

  const query = new URLSearchParams(search);

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();

    try {
      const token = query.get('token');

      const { password, passwordConfirmation } = resetPasswordFormData;

      if (password !== passwordConfirmation) {
        toast.error(
          'Os campos de senha e confirmação de senha devem ser iguais',
        );
        return;
      }

      if (!token) {
        toast.error(
          'Ocorreu um erro, por favor abra novamente o link no e-mail recebido para alterar sua senha',
        );
        return;
      }

      const dataToSubmit = {
        token,
        password,
        password_confirmation: passwordConfirmation,
      };

      await api.post('/password/reset', dataToSubmit);

      setWasSent(true);
    } catch (error: any) {
      toast.error(
        error?.response?.data?.message ||
          error?.message ||
          'Ocorreu um erro ao resetar sua senha',
      );
    }
  };

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;

    setResetPasswordFormData({
      ...resetPasswordFormData,
      [name]: value,
    });
  };

  return (
    <Container>
      <LeftTop />

      <LeftCenter />

      <LeftBottom />

      <RegisterWrapper>
        <RepfyLogo />

        <h1>Prestadores</h1>

        <ResetPasswordForm onSubmit={handleSubmit}>
          {wasSent ? (
            <>
              <h2 className="reset-password-form__title">
                Senha alterada com sucesso!
              </h2>

              <p className="reset-password-form__subtitle">
                Volte à aplicação para realizar o login
              </p>
            </>
          ) : (
            <>
              <h2 className="reset-password-form__title">
                Redefinição de senha
              </h2>

              <p className="reset-password-form__subtitle">
                Por favor digite a sua nova senha abaixo
              </p>
              <input
                name="password"
                type="password"
                className="reset-password-form__input"
                placeholder="Nova senha"
                minLength={8}
                value={resetPasswordFormData.password}
                onChange={handleInputChange}
                required
              />
              <input
                name="passwordConfirmation"
                type="password"
                className="reset-password-form__input"
                placeholder="Confirmar nova senha"
                minLength={8}
                onChange={handleInputChange}
                value={resetPasswordFormData.passwordConfirmation}
                required
              />
              <button
                type="submit"
                className="reset-password-form__submit-button"
              >
                Salvar senha
              </button>
            </>
          )}
        </ResetPasswordForm>
      </RegisterWrapper>

      <RightTop />

      <RightBottom />
    </Container>
  );
};
